import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment';
import PButton from 'primevue/button';
import { convertDateToDisplay } from '~/utils/date-time';
import { EVENT_STATES, BENCHMARK_FOR_AVAILABLE_TICKETS, sortByDisplayOrder } from '~/utils/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'DateList',
  props: {
    occurrences: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    event: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['input', 'selectOccurrence'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t,
      d = _useI18n.d;
    // Replaces $vuetify.breakpoint.xsOnly
    var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.xsOnly;
    var eventStates = EVENT_STATES;
    var futureOccurrences = computed(function () {
      return props.occurrences.filter(function (occurrence) {
        return moment(occurrence.endAt).isAfter(moment());
      });
    });
    var pastOccurrences = computed(function () {
      return props.occurrences.filter(function (occurrence) {
        return moment(occurrence.endAt).isBefore(moment());
      });
    });

    /**
     * One accordion group, replacing a `v-expansion-panels`. A lone occurrence
     * stays expanded and cannot be collapsed, which is what the `readonly` and
     * `value` pair used to express; anything else opens one panel at a time.
     */
    function usePanelGroup(occurrences) {
      var isExpandable = computed(function () {
        return occurrences.value.length > 1;
      });
      var openPanel = ref(isExpandable.value ? null : 0);

      // The old bound value was derived from the count, so it reset on a change
      watch(isExpandable, function (expandable) {
        openPanel.value = expandable ? null : 0;
      });
      function toggle(index) {
        if (!isExpandable.value) {
          return;
        }
        openPanel.value = openPanel.value === index ? null : index;
        emit('input', openPanel.value);
      }
      return {
        openPanel: openPanel,
        isExpandable: isExpandable,
        toggle: toggle
      };
    }
    var _usePanelGroup = usePanelGroup(futureOccurrences),
      futureOpenPanel = _usePanelGroup.openPanel,
      futureIsExpandable = _usePanelGroup.isExpandable,
      toggleFuturePanel = _usePanelGroup.toggle;
    var _usePanelGroup2 = usePanelGroup(pastOccurrences),
      pastOpenPanel = _usePanelGroup2.openPanel,
      pastIsExpandable = _usePanelGroup2.isExpandable,
      togglePastPanel = _usePanelGroup2.toggle;

    /**
     * Height animation for the expanding panel, matching the timing of the
     * Vuetify expand transition it replaces.
     */
    function expandEnter(el) {
      el.style.height = '0';
      // Reading layout forces a reflow, so the transition starts from zero
      el.getBoundingClientRect();
      el.style.height = "".concat(el.scrollHeight, "px");
    }
    function expandAfterEnter(el) {
      el.style.height = '';
    }
    function expandLeave(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
      el.getBoundingClientRect();
      el.style.height = '0';
    }
    function expandAfterLeave(el) {
      el.style.height = '';
    }

    /**
     * A card is only a disclosure control when the group can be collapsed at all
     * and the occurrence has timeslots to reveal. Anything else has nothing to
     * announce, since the panel content is rendered only for timeslots.
     */
    function isDisclosure(occurrence, groupIsExpandable) {
      var _occurrence$timeslot;
      return groupIsExpandable && ((_occurrence$timeslot = occurrence.timeslot) === null || _occurrence$timeslot === void 0 ? void 0 : _occurrence$timeslot.length) > 0;
    }
    function hasTicketConfig(item) {
      return item.ticketConfig.length > 0;
    }
    // prints message about number of ticket that can be bought in the timeslot if that number is lower than defined benchmark
    function showRemainingTicketsInTimeslot(timeslot) {
      // available tickets based on ticket config information
      var availableTicketConfigTickets = 0;
      // calculates available tickets for limited timeslot if some tickets were already bought
      if (timeslot.ticketConfigCapacity > 0 && (timeslot === null || timeslot === void 0 ? void 0 : timeslot.associatedTicketConfig.length) > 0) {
        timeslot.associatedTicketConfig.forEach(function (atc) {
          var foundTicketConfig = timeslot.ticketConfig.find(function (tc) {
            return tc.id === atc;
          });
          availableTicketConfigTickets += foundTicketConfig.availableTickets;
        });
      }
      // calculates available tickets for regular timeslot or limited on if no tickets were bought
      else {
        timeslot.ticketConfig.forEach(function (tc) {
          availableTicketConfigTickets += tc.availableTickets;
        });
      }
      // available tickets are calculated based on timeslot capacity and previously calculated number
      var remainingTickets = Math.min(timeslot.availableTickets, availableTicketConfigTickets);
      if (remainingTickets < BENCHMARK_FOR_AVAILABLE_TICKETS) {
        return t('cart.remainingTicketsInTimeslot', {
          remainingTickets: remainingTickets
        }).toUpperCase();
      }
    }
    function formattedCity(occurrence) {
      var _occurrence$venue, _occurrence$venue$add, _occurrence$venue$add2, _occurrence$venue3, _occurrence$venue3$ad, _occurrence$venue3$ad2;
      var data = [];
      if (((_occurrence$venue = occurrence.venue) === null || _occurrence$venue === void 0 ? void 0 : (_occurrence$venue$add = _occurrence$venue.address) === null || _occurrence$venue$add === void 0 ? void 0 : (_occurrence$venue$add2 = _occurrence$venue$add.city) === null || _occurrence$venue$add2 === void 0 ? void 0 : _occurrence$venue$add2.length) > 0) {
        var _occurrence$venue2, _occurrence$venue2$ad;
        data.push((_occurrence$venue2 = occurrence.venue) === null || _occurrence$venue2 === void 0 ? void 0 : (_occurrence$venue2$ad = _occurrence$venue2.address) === null || _occurrence$venue2$ad === void 0 ? void 0 : _occurrence$venue2$ad.city);
      }
      if (((_occurrence$venue3 = occurrence.venue) === null || _occurrence$venue3 === void 0 ? void 0 : (_occurrence$venue3$ad = _occurrence$venue3.address) === null || _occurrence$venue3$ad === void 0 ? void 0 : (_occurrence$venue3$ad2 = _occurrence$venue3$ad.country) === null || _occurrence$venue3$ad2 === void 0 ? void 0 : _occurrence$venue3$ad2.length) > 0) {
        var _occurrence$venue4, _occurrence$venue4$ad;
        data.push((_occurrence$venue4 = occurrence.venue) === null || _occurrence$venue4 === void 0 ? void 0 : (_occurrence$venue4$ad = _occurrence$venue4.address) === null || _occurrence$venue4$ad === void 0 ? void 0 : _occurrence$venue4$ad.country);
      }
      return data.join(', ');
    }
    function parsedDates(occurrences) {
      return occurrences.map(function (occurrence) {
        return _objectSpread(_objectSpread({}, occurrence), {}, {
          timeslot: sortByDisplayOrder(occurrence === null || occurrence === void 0 ? void 0 : occurrence.timeslot),
          momentStartAt: moment(occurrence.startAt)
        });
      });
    }
    function eventName(occurrence) {
      var _occurrence$name, _occurrence$status;
      // Fallback if the occurrence does not have a name, which shouldn't happen
      var name = (_occurrence$name = occurrence === null || occurrence === void 0 ? void 0 : occurrence.name) !== null && _occurrence$name !== void 0 ? _occurrence$name : props.event.name;
      var status = (_occurrence$status = occurrence === null || occurrence === void 0 ? void 0 : occurrence.status) !== null && _occurrence$status !== void 0 ? _occurrence$status : props.event.status;
      if (status === eventStates.CANCELED) {
        return "".concat(name, " [").concat(t('myEvents.statusFilter.canceled').toUpperCase(), "] ");
      }
      if (eventInPresale(occurrence)) {
        return "[".concat(t('home.events.presale').toUpperCase(), "] ").concat(name);
      }
      return name;
    }
    function formatTime(time) {
      var localTime = convertDateToDisplay(time, props.event.timezoneName);
      return d(localTime, 'HH_mm');
    }
    function eventInPresale(occurrence) {
      return occurrence.presaleEndAt && moment(occurrence.presaleEndAt).isAfter(moment());
    }
    function isTimeslotOnSale(timeslot) {
      var now = moment();
      var start = timeslot.startSaleAt ? moment(timeslot.startSaleAt) : null;
      var end = timeslot.endSaleAt ? moment(timeslot.endSaleAt) : null;
      if (start && end) {
        return now.isBetween(start, end, null, '[]');
      }
      if (start) {
        return now.isSameOrAfter(start);
      }
      if (end) {
        return now.isSameOrBefore(end);
      }
      return true;
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      t: t,
      d: d,
      isMobile: isMobile,
      eventStates: eventStates,
      futureOccurrences: futureOccurrences,
      pastOccurrences: pastOccurrences,
      usePanelGroup: usePanelGroup,
      futureOpenPanel: futureOpenPanel,
      futureIsExpandable: futureIsExpandable,
      toggleFuturePanel: toggleFuturePanel,
      pastOpenPanel: pastOpenPanel,
      pastIsExpandable: pastIsExpandable,
      togglePastPanel: togglePastPanel,
      expandEnter: expandEnter,
      expandAfterEnter: expandAfterEnter,
      expandLeave: expandLeave,
      expandAfterLeave: expandAfterLeave,
      isDisclosure: isDisclosure,
      hasTicketConfig: hasTicketConfig,
      showRemainingTicketsInTimeslot: showRemainingTicketsInTimeslot,
      formattedCity: formattedCity,
      parsedDates: parsedDates,
      eventName: eventName,
      formatTime: formatTime,
      eventInPresale: eventInPresale,
      isTimeslotOnSale: isTimeslotOnSale,
      PButton: PButton
    };
  }
});